/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SurveyBasedComponent from "core/components/forc/abstract/survey-based-component";
import styles from "./index.module.css";
export default class PersonalBackgroundFormComponent extends SurveyBasedComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "styles", styles);
  }
  computePayload() {
    const payload = super.computePayload();
    if (payload.definitiveContraception !== "no") {
      delete payload.contraceptionMethod;
    }
    return payload;
  }
}
_defineProperty(PersonalBackgroundFormComponent, "forcDisplayName", "Antécédents personnels et familiaux");
_defineProperty(PersonalBackgroundFormComponent, "fullComponentId", "personal-background/form");